/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import CloseIcon from "@mui/icons-material/Close";
import swal from "sweetalert";
import {
  NavLink,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import Loading from "../components/Loading";
import * as _ from "lodash";
import SyncIcon from "@mui/icons-material/Sync";
import { useLocation } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  DateTimePicker,
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  FormControl,
  FormControlLabel,
  Button,
  Checkbox,
  Alert,
  Snackbar,
  Modal,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Autocomplete,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
} from "@mui/material";
import {
  Add as AddIcon,
  ArrowRightAlt,
  Clear,
  ExpandMore,
  FileDownload,
} from "@mui/icons-material";
import { spacing } from "@mui/system";
import { Formik } from "formik";
import { connect } from "react-redux";
import axios from "../../CustomAxios";
import DocumentUpload from "../components/DocumentUpload";
import CreateProductionReport from "./CreateProductionReport";
import UpdateProductionReport from "./UpdateProductionReport";
import { Edit as EditIcon } from "@mui/icons-material";

const Card = styled(MuiCard)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function FormDetails({
  auths,
  missingPermissions,
  setUp,
  up,
  user,
  details,
  urls,
  job_id,
  setUrls,
  ApCompanies,
  userPermissions,
  customerCompanies,
  initialCustomerCompanyUsers,
}) {
  const productionReportRef = useRef(null);
  const location = useLocation();
  const [init, setInit] = useState(0);
  const [is_deleted, setIsDeleted] = useState(location.state?.job?.is_deleted);
  const [plates, setPlates] = React.useState(details?.plates || []);
  const [open, setOpen] = React.useState(false);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [ApUsers, setApUsers] = useState([]);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const status = ["new", "studio", "ctp_impose", "ctp", "delivery"];
  const [nextStatus, setNextStatus] = useState("");
  const [previousStatus, setPreviousStatus] = useState("");
  const [updateType, setUpdateType] = useState("");
  const [currentStatus, setCurrentStatus] = useState(details?.current_status);
  const formData = new FormData();
  const [actionBy, setActionBy] = useState("");
  const [images, setImages] = useState({});
  const [documents, setDocuments] = useState({});
  const [currentApCompany, setCurrentApCompany] = useState(details?.ap_company?._id);
  const [apMachines, setApMachines] = useState([]);
  const [inventoryAlert, setInventoryAlert] = useState({
    open: false,
    message: "",
  });
  const [isCustomerCompanyChanged, setIsCustomerCompanyChanged] =
    useState(false);
  const [audit_logs, setAuditLogs] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [address, setAddress] = useState(
    customerCompanies.filter(
      (item) => item._id === details?.customer_company?._id
    )[0]?.addresses
  );
  const [
    selectedCustomerCompanyAddresses,
    setSelectedCustomerCompanyAddresses,
  ] = useState(findCustomerCompanyDeliveryOptions());
  const [formChanged, setFormChanged] = useState(false);
  const [selectedCustomerCompanyInput, setSelectedCustomerCompanyInput] =
    useState(findCurrentSelectedCustomerCompany());
  const [
    selectedCustomerCompanyUserInput,
    setSelectedCustomerCompanyUserInput,
  ] = useState(findCurrentSelectedCustomerCompanyUser());
  const [customerCompanyUserOptions, setCustomerCompanyUserOptions] = useState(
    initialCustomerCompanyUsers
  );
  const categories = ["Commercial", "Web", "Semi-Packaging", "Packaging", "Other"];
  const [productionReports, setProductionReports] = useState([]);
  const [hasExistingReport, setHasExistingReport] = useState(false);
  const [productionReportLoader, setProductionReportLoader] = useState(true);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(5);
  const [metadata, setMetadata] = useState([]);
  const [openLogsModal, setOpenLogsModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openCreateReportModal, setOpenCreateReportModal] = useState(false);
  const [openUpdateReportModal, setOpenUpdateReportModal] = useState(false);
  const [selectedProductionReport, setSelectedProductionReport] = useState();
  const formikRef = useRef();
  const platesRef = useRef(plates);
  useEffect(() => {
    platesRef.current = plates;
  }, [plates]);

  function findCurrentSelectedCustomerCompany() {
    return customerCompanies.find(
      (it) => it._id === details?.customer_company?._id
    );
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (formikRef.current) {
      formikRef.current.validateForm();
    }
  }, [plates]);

  const ProductionReportsTable = ({
    productionReports,
    metadata,
    loading
  }) => {
    const { total_results } = metadata;
    return (
      <Paper elevation={3} style={{ padding: "2% 3%", marginBottom: 20, minHeight: "200px" }}>
        <div ref={productionReportRef}>
          <Grid container justifyContent="space-between" alignItems="center" mb={4}>
            <Typography variant="h4" color="primary" gutterBottom>
              Production Reports
            </Typography>

            {userPermissions?.includes('create_dpr') && <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setOpenCreateReportModal(true)}
            >
              New Entry
            </Button>}
          </Grid>
        </div>
        {loading ?
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <CircularProgress />
          </Box> :
          productionReports.length > 0 ? <><TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Created At</TableCell>
                  <TableCell>Docket By</TableCell>
                  <TableCell>Plate Size</TableCell>
                  <TableCell>Technology</TableCell>
                  <TableCell>Plate Made By</TableCell>
                  <TableCell>Challan ID</TableCell>
                  <TableCell>Bill ID</TableCell>
                  <TableCell>Baking Quantity</TableCell>
                  <TableCell>CTP Quantity</TableCell>
                  <TableCell>Machine</TableCell>
                  <TableCell>Comment</TableCell>
                  <TableCell>View Logs</TableCell>
                  {userPermissions?.includes('update_dpr') && <TableCell>Update</TableCell>}
                </TableRow>
              </TableHead>

              <TableBody>
                {productionReports.map((data) => {
                  const {
                    _id,
                    createdAt,
                    job_id,
                    plate,
                    audit_logs,
                    baking_quantity,
                    ctp_quantity,
                    comment,
                  } = data;

                  let ap_machine = apMachines.find(m => m._id === data.ap_machine);
                  const plateSize = plate
                    ? `${plate?.height} x ${plate?.width} x ${plate?.thickness}`
                    : '';

                  const plateMadeBy = audit_logs?.[0]?.action_by?.name || '';

                  const technology = plate?.technology?.name || '';

                  const docketBy = job_id?.docket_details?.action_by?.name || '';

                  const challanId = job_id?.challan_created && job_id?.associated_challan
                    ? job_id.associated_challan.challan_id
                    : '';

                  const billId = job_id?.bill_created && job_id?.associated_bill
                    ? job_id.associated_bill.bill_id
                    : '';

                  return (
                    <TableRow key={_id}>
                      <TableCell>{(createdAt) ? new Date(createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }) : '-'}</TableCell>
                      <TableCell>{docketBy}</TableCell>
                      <TableCell>{plateSize}</TableCell>
                      <TableCell>{technology}</TableCell>
                      <TableCell>{plateMadeBy}</TableCell>
                      <TableCell>{challanId ? challanId : '-'}</TableCell>
                      <TableCell>{billId ? billId : '-'}</TableCell>
                      <TableCell>{baking_quantity}</TableCell>
                      <TableCell>{ctp_quantity}</TableCell>
                      <TableCell>{ap_machine ? `${ap_machine?.name}-${ap_machine?.serial_no}` : '-'}</TableCell>
                      <TableCell>{comment || '-'}</TableCell>
                      <TableCell><VisibilityIcon
                        style={{ color: "green", cursor: "pointer" }}
                        onClick={() => { handlLogsModal(data) }}
                      /></TableCell>
                      {userPermissions?.includes('update_dpr') && <TableCell><EditIcon
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={() => { handleUpdateReport(data); }}
                      /></TableCell>}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
            <TablePagination
              component="div"
              count={total_results}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={limit}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]}
            /> </> : <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            No production reports found
          </Box>
        }
      </Paper>
    );
  };

  function findCurrentSelectedCustomerCompanyUser() {
    return initialCustomerCompanyUsers.find(
      (it) => it._id === details?.customer_company_user?._id
    );
  }

  const handleUpdateReport = (row) => {
    setSelectedProductionReport(row);
    setOpenUpdateReportModal(true);
  };

  const handlLogsModal = (row) => {
    setSelectedProductionReport(row);
    setAuditLogs(row?.audit_logs || []);
    setOpenLogsModal(true);
  };

  function findCustomerCompanyDeliveryOptions() {
    return (
      customerCompanies.find((it) => it._id === details?.customer_company?._id)
        ?.addresses || []
    );
  }

  const handleOpen = (type) => {
    setUpdateType(type);
    setOpen(true);
  };
  const handleDown = () => {
    setUpdateType("");
    setOpen(false);
  };

  useEffect(() => {
    const fetchProductionReports = async () => {
      try {
        setLoading(true);
        if (details?.current_status === 'ctp' && details?.ap_company?._id) {
          const config = {
            headers: {
              Authorization: "Bearer " + authData?.access_token,
            },
          };

          const { data } = await axios.get(
            `/api/v1/${authData?.type}/production_report/${details?._id}/${details?.ap_company?._id}?page=${page + 1}&limit=${limit}`,
            config
          );
          if (data?.success && data?.data?.length > 0) {
            if (plates.length > 0) {
              setProductionReports(data.data.filter(report =>
                plates.some(plate =>
                  plate?._id?.toString() === report?.unique_id?.toString()
                )
              ));
            }
            setHasExistingReport(true);
            setMetadata(data?.metadata || []);

            // Fixed: assign to local variable, not optional chain
            const firstReport = data.data[0];
            if (firstReport && Array.isArray(firstReport.audit_logs)) {
              const seen = new Set();
              firstReport.audit_logs = firstReport.audit_logs.filter((log) => {
                const key = `${log?.action_by?._id}-${log?.timestamp}`;
                if (seen.has(key)) {
                  return false;
                }
                seen.add(key);
                return true;
              });
            }

            setAuditLogs(firstReport?.audit_logs || []);
          }
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching production reports:", error);
      } finally {
        setLoading(false);
        setProductionReportLoader(false);
      }
    };

    if (details?.current_status === 'ctp') {
      fetchProductionReports();
    }
  }, [details, up, page, limit]);

  useEffect(() => {
    const current = details?.current_status;
    const ind = status.indexOf(current);
    if (ind < status.length && ind !== -1) {
      setNextStatus(status[ind + 1]);
      if (status[ind - 1] && !details?.challan_created) {
        setPreviousStatus(status[ind - 1]);
      } else {
        setPreviousStatus(false);
      }
    } else {
      setNextStatus(false);
      setPreviousStatus(false);
    }
  }, [details]);

  const updateStatus = async () => {
    setLoader(true);
    try {
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      if (authData?.type === "super_admin") {
        if (!actionBy) {
          setErr("Select Action By");
          snackRef.current.click();
          setLoader(false);
          return;
        }
      }
      let br = 0;

      Object.values(images).map((doc, i) => {
        if (!documents[i]) {
          setErr("Document Name field cannot be empty");
          setSuccess(false);
          setLoader(false);
          snackRef.current.click();
          br = 1;
          return;
        }
      });
      let plateBr = 0;

      if (nextStatus === "delivery" && updateType === "next") {
        plates.map((plate) => {
          if (!plate.quantity) {
            plateBr = 1;
            setErr(
              "Please fill all plate quantities before updating status to CTP"
            );
            setLoader(false);
            setSuccess(false);
            snackRef.current.click();
            return;
          }
        });
        if (!plateBr) {
          plates.map((plate) => {
            formData.set(`plate_${plate.plate_id}`, plate.quantity);
          });
        }
      }
      if (!br && !plateBr) {
        handleDown();
        setLoader(true);
        Object.values(images).map((image, i) => {
          formData.set(`document_${i + 1}_file`, image);
        });
        Object.values(documents).map((doc, i) => {
          formData.set(`document_${i + 1}_name`, doc);
        });
        formData.set("action_by", actionBy);
        formData.set("previous", updateType === "previous" ? true : false);
        const config = {
          headers: {
            Authorization: "Bearer " + authData?.access_token,
          },
        };

        const editplatedata = await axios.put(
          `/api/v1/${authData?.type}/jobs/${details?._id}/plates`,
          {
            plates,
          },
          config
        );
        if (editplatedata?.data?.success) {
          const { data } = await axios.put(
            `/api/v1/${authData?.type}/jobs/${details?._id}/${updateType === "next" ? nextStatus : previousStatus}`,
            formData,
            config
          );
          if (data?.success) {
            handleDown();
            setErr("");
            setSuccess(true);
            setMessage("Status Updated Successfully");
            setUpdateType("");
            setCurrentStatus(
              updateType === "next" ? nextStatus : previousStatus
            );
            const ind = status.indexOf(currentStatus);
            setImages({});
            setDocuments({});
            setActionBy("");
            if (ind < status.length && ind !== -1) {
              setNextStatus(status[ind + 1]);
              if (status[ind - 1] && !details?.challan_created) {
                setPreviousStatus(status[ind - 1]);
              } else {
                setPreviousStatus(false);
              }
            } else {
              setPreviousStatus(false);
              setNextStatus(false);
            }
            setUp(up + 1);
            snackRef.current.click();
            setLoader(false);
          }
        }
      }
    } catch (e) {
      console.log(e);
      setLoader(false);
      setSuccess(false);
      setErr(e?.response?.data?.error || "An error occurred");
      snackRef.current.click();
    }
  };

  const checkDPRCompletion = () => {
    if (!hasExistingReport) return false;

    let platesBakeSum = 0;
    let platesCtpSum = 0;
    let reportsBakeSum = 0;
    let reportsCtpSum = 0;

    plates?.forEach((plate) => {
      platesBakeSum += plate?.bake || 0;
      platesCtpSum += plate?.ctp_plate_count || 0;
    });

    productionReports?.forEach((report) => {
      reportsBakeSum += report?.baking_quantity || 0;
      reportsCtpSum += report?.ctp_quantity || 0;
    });

    return (
      platesBakeSum <= reportsBakeSum &&
      platesCtpSum <= reportsCtpSum
    );
  };

  useEffect(() => {
    if (productionReports.length > 0 && plates.length > 0) {
      checkDPRCompletion();
    }
  }, [productionReports, plates, details]);

  const getJobs = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData?.access_token,
        },
      };

      if (userData?.type === "ap_user" || userData?.type === "super_admin") {
        const { data } = await axios.get(
          `/api/v1/${userData?.type}/jobs?is_table=true`,
          config
        );
        if (data?.success) {
          setJobs(data?.data || []);
        }
      } else {
        if (
          auths?.user?.customer_company?._id !== undefined &&
          auths?.user !== null
        ) {
          const { data } = await axios.get(
            `/api/v1/${userData?.type}/${auths?.user?.customer_company?._id}/jobs?is_table=true`,
            config
          );
          if (data?.success) {
            setJobs(data?.data?.data || []);
          }
        }
      }
    } catch (e) {
      console.log("error in job", e);
    }
  };

  useEffect(() => {
    getApUsers(details?.ap_company?._id);
    getInventory(details?.customer_company?._id);
    getCompanyInventory(
      details?.ap_company?._id,
      details?.plates,
      inventoryAlert,
      setInventoryAlert
    );
    getJobs();
  }, [details]);

  useEffect(() => {
    if (details?.ap_company?._id) {
      getApMachines(details?.ap_company?._id);
    }
  }, [details?.ap_company?._id]);

  const { setPreventNavigation } = useOutletContext();

  useEffect(() => {
    if (formChanged) {
      const unloadCallback = (event) => {
        event.preventDefault();
        event.returnValue = "";
        return "";
      };

      window.addEventListener("beforeunload", unloadCallback);
      return () => window.removeEventListener("beforeunload", unloadCallback);
    }
  }, [formChanged]);

  const snackRef = useRef(null);
  const [state, setState] = useState({
    op: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, op } = state;
  const handleClick = (newState) => () => {
    setState({ op: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, op: false });
  };

  const plateHandle = (i, obj) => (e) => {
    let plate = [...plates];

    if (obj === "ap_machine") {
      plate[i][obj] = e.target.value;
    } else if (obj === "not_to_bill" || obj === "production_rejection") {
      plate[i][obj] = e.target.checked;
    } else {
      if (obj === "gripper") {
        if (e.target.value <= 99.99 && e.target.value >= 0.0) {
          plate[i][obj] = parseFloat(e.target.value);
        }
      } else {
        plate[i][obj] = e.target.value;
      }
    }
    setPlates(plate);
    let selected = [];
    plate.map((pl) => {
      selected.push(pl?.plate_id);
    });
    setSelectedPlates(selected);
  };

  useEffect(() => {
    let selected = [];
    if (details?.plates) {
      details?.plates.map((pl) => {
        selected.push(pl?.plate_id);
      });
    }
    setSelectedPlates(selected);
  }, []);

  const addPlate = () => {
    setPlates((prev) => [...prev, {}]);
  };

  const getInventory = async (companyId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData?.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${userData?.type}/customer_company/${companyId}/plate/effective`,
        config
      );
      if (data?.success) {
        let initialInventory = data?.data?.data || [];
        setInventory(initialInventory.filter((i) => i?.deactivated === false));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getApMachines = async (companyId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData?.access_token,
        },
      };
      const { data } = await axios.get(`/api/v1/${userData?.type}/machine/${companyId}`, config);
      if (data?.success) {
        setApMachines(data?.data || []);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getApUsers = async (companyId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData?.access_token,
        },
      };
      let url = "";
      if (userData?.type === "ap_user") {
        url = `/api/v1/ap_user/ops`;
      } else {
        url = `/api/v1/${userData?.type}/ap_user?company_id=${companyId}`;
      }
      const { data } = await axios.get(url, config);
      if (data?.success) {
        setApUsers(data?.data?.data || []);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getCustomerUsers = async (companyId, setCustomerCompanyUserOptions) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData?.access_token,
        },
      };

      const { data: response } = await axios.get(
        `/api/v1/${userData?.type}/customer_company_user?company_id=${companyId}`,
        config
      );
      if (response?.success) {
        setCustomerCompanyUserOptions(response?.data?.data || []);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const editJob = async (values, resetForm) => {
    try {
      const currentPlates = platesRef.current;
      const platesWithMachines = currentPlates?.map(plate => ({
        ...plate,
        ap_machine: plate?.ap_machine || null
      })) || [];

      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: { Authorization: "Bearer " + userData?.access_token },
      };

      if (currentPlates?.length === 0) {
        showErrorAlert(`Please add at least one plate associated with ${selectedCustomerCompanyInput?.name}`);
        return;
      }

      if (!selectedCustomerCompanyUserInput?.name) {
        showErrorAlert(`Please add Customer User associated with ${selectedCustomerCompanyInput?.name}`);
        return;
      }

      setLoader(true);
      const { data } = await axios.put(
        `/api/v1/${userData?.type}/jobs/${details?._id}`,
        {
          name: values?.name,
          ap_company: values?.ap_company,
          ap_company_user: values?.ap_company_user,
          ap_contact_number: values?.ap_contact_number,
          pc_ap: values?.pc_ap,
          cut: values?.cut,
          open_height: values?.open_height,
          open_width: values?.open_width,
          page: values?.page,
          binding_style: values?.binding_style,
          received_date: new Date(values?.recieved_date).toISOString(),
          required_date: new Date(values?.required_date).toISOString(),
          total_form: values?.total_form,
          fb: values?.fb,
          sb: values?.sb,
          dg: values?.dg,
          os: values?.os,
          instructions: values?.instructions,
          is_deleted,
          plates: platesWithMachines,
          job_refer: values?.job_refer,
          delivery: values?.delivery,
          customer_company: selectedCustomerCompanyInput?._id,
          customer_company_user: selectedCustomerCompanyUserInput?._id,
          customer_contact_number: values?.customer_contact_number,
          category: values?.category,
          docket_by: details?.docket_details?.action_by?.name,
        },
        config
      );

      if (data?.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        navigate("/dashboard/jobs", {
          state: { message: "Details Saved Successfully", success: true },
        });
        setPreventNavigation(false);
      }
    } catch (e) {
      setLoader(false);
      console.log(e);
      setErr(e?.response?.data?.error || "An error occurred");
      snackRef.current.click();
    }
  };

  const [selectedPlates, setSelectedPlates] = useState(details?.plates || []);
  const [cost, setCost] = useState(details?.job_total_cost || 0);
  const [priceChanges, setPriceChanges] = useState({});
  const [priceResolved, setPriceResolved] = useState({});
  const removePlate = (i, id) => {
    if (id) {
      setSelectedPlates((prev) => [...prev.filter((x) => x !== id)]);
    }
    setPlates((prev) => [...prev.slice(0, i), ...prev.slice(i + 1)]);
  };

  useEffect(() => {
    if (init) {
      totalPrice();
    } else {
      setInit(1);
    }
  }, [plates]);

  const setGripper = (id, i) => {
    let gripper;
    inventory.map((plate) => {
      if (plate?.plate_id === id) {
        gripper = plate?.gripper;
      }
    });
    let plate = [...plates];
    plate[i]["gripper"] = gripper;
    setPlates(plate);
  };

  const deleteDocument = async (key) => {
    try {
      setUrls([]);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData?.access_token,
        },
      };
      const { data } = await axios.delete(
        `/api/v1/${authData?.type}/media/jobs/${job_id}/${key}`,
        config
      );
      if (data?.success) {
        setSuccess(true);
        setErr("");
        setMessage("Document Deleted successfully");
        snackRef.current.click();
        setUp(up + 1);
      }
    } catch (e) {
      setErr(e?.response?.data?.error || "An error occurred");
      snackRef.current.click();
      setLoader(false);
      console.log(e);
    }
  };

  const totalPrice = () => {
    let totalCost = 0;
    plates?.forEach(plate => {
      const inv = inventory?.find(it => it?.plate_id === plate?.plate_id);
      if (inv) {
        totalCost += (plate?.bake || 0) * (plate?.baking_cost ?? inv?.baking_cost);
        totalCost += (plate?.printout || 0) * (plate?.print_cost ?? inv?.print_cost);
        totalCost += (plate?.quantity || 0) * (plate?.selling_cost ?? inv?.selling_cost);
      }
    });
    setCost(totalCost);
  };

  let InputProps = {
    readOnly: missingPermissions.length > 0 ? true : false,
  };

  const handleJobSync = async () => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData?.access_token,
        },
      };

      const { data } = await axios.put(
        `/api/v1/${userData?.type}/jobs/${job_id}/sync`,
        {},
        config
      );

      if (data?.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        setMessage("Job Synced Successfully");
      }
    } catch (e) {
      setErr(e?.response?.data?.error || "An error occurred");
      snackRef.current.click();
      setLoader(false);
      console.log(e);
    }
  };

  function showErrorAlert(message) {
    setErr(message);
    snackRef.current.click();
  }

  const checkPriceDiscrepancies = () => {
    const changes = {};
    plates?.forEach((plate, idx) => {
      if (!plate?.plate_id) return;
      const invItem = inventory?.find(it => it?.plate_id === plate?.plate_id);
      if (invItem) {
        const hasChange =
          (plate?.baking_cost != null && plate?.baking_cost !== invItem?.baking_cost) ||
          (plate?.print_cost != null && plate?.print_cost !== invItem?.print_cost) ||
          (plate?.selling_cost != null && plate?.selling_cost !== invItem?.selling_cost) ||
          (plate?.gripper != null && plate?.gripper !== invItem?.gripper);
        if (hasChange && !priceResolved[idx]) {
          changes[idx] = true;
        }
      }
    });
    setPriceChanges(changes);
  };

  useEffect(() => {
    if (inventory.length > 0 && plates.length > 0) {
      checkPriceDiscrepancies();
    }
  }, [inventory, plates]);

  const applyNewPrices = (i) => {
    const newPlates = [...plates];
    const plate = newPlates[i];
    const invItem = inventory?.find(it => it?.plate_id === plate?.plate_id);
    if (invItem) {
      plate.baking_cost = invItem?.baking_cost;
      plate.print_cost = invItem?.print_cost;
      plate.selling_cost = invItem?.selling_cost;
      plate.gripper = invItem?.gripper;
    }
    setPlates(newPlates);
    setPriceChanges(prev => {
      const updated = { ...prev };
      delete updated[i];
      return updated;
    });
    setPriceResolved(prev => ({ ...prev, [i]: true }));
  };

  const keepOldPrices = (i) => {
    setPriceChanges(prev => {
      const updated = { ...prev };
      delete updated[i];
      return updated;
    });
    setPriceResolved(prev => ({ ...prev, [i]: true }));
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={{
          name: details?.name,
          ap_company: details?.ap_company?._id,
          ap_company_user: details?.ap_company_user?._id,
          ap_contact_number: details?.ap_contact_number,
          pc_ap: details?.pc_ap,
          total_form: details?.total_form,
          cut: details?.cut,
          open_height: details?.open_height || "",
          open_width: details?.open_width || "",
          page: details?.page,
          binding_style: details?.binding_style,
          required_date: new Date(details?.required_date),
          recieved_date: new Date(details?.received_date),
          fb: details?.fb || "",
          sb: details?.sb || "",
          dg: details?.dg || "",
          os: details?.os || "",
          instructions: details?.instructions,
          job_refer: details?.referred_job?._id,
          delivery: details?.delivery,
          customer_contact_number: details?.customer_contact_number,
          category: details?.category,
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().max(255).required("name is required"),
          pc_ap: Yup.string().max(255).required("PC/AP is required"),
          cut: Yup.string().max(255).required("cut is required"),
          open_height: Yup.string()
            .max(255)
            .required("Open-Height is required"),
          open_width: Yup.string().max(255).required("Open-Width is required"),
          page: Yup.string().required("page is required"),
          binding_style: Yup.string()
            .max(255)
            .required("binding style is required"),
          delivery: Yup.object().required("Delivery Address is required"),

          required_date: Yup.string().required("Delivery Date is missing"),
          recieved_date: Yup.string().required("Received date is missing"),
          fb: Yup.string().matches(
            /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
            "F/B should be in range 1 - 3999"
          ),
          sb: Yup.string().matches(
            /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
            "S/B should be in range 1 - 3999"
          ),
          dg: Yup.string().matches(
            /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
            "D/G should be in range 1 - 3999"
          ),
          os: Yup.string().matches(
            /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
            "O/S should be in range 1 - 3999"
          ),
          instructions: Yup.string(),
          ap_company: Yup.string().required("AP company is required"),
          ap_company_user: Yup.string().required("AP company User is required"),
        })}
        validate={(values) => {
          const errors = {};
          const hasRejectionOrNotToBill = plates.some(
            plate => plate?.not_to_bill || plate?.production_rejection
          );

          if (hasRejectionOrNotToBill && !values?.instructions) {
            errors.instructions = "Instructions are required when any plate is marked as 'Not to Bill' or 'Production Rejection'";
          }
          return errors;
        }}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            editJob(values, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          touched,
          values,
        }) => (
          <>
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={op}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  {message}
                </Alert>
              ) : null}
            </Snackbar>

            {!loader ? (
              <form
                noValidate
                onSubmit={handleSubmit}
                autoComplete="off"
                onChange={() => {
                  setFormChanged(true);
                  setPreventNavigation(true);
                }}
              >
                {/* Status Update */}
                <Grid
                  container
                  spacing={2}
                  style={{
                    paddingBottom: "1%",
                  }}
                >
                  {currentStatus === 'ctp' && (
                    <Grid item xs={12}>
                      <Alert severity={
                        checkDPRCompletion() ? "success" : "error"
                      }>
                        {!hasExistingReport ? (
                          "Production Report not created - status change disabled"
                        ) : checkDPRCompletion() ? (
                          "All DPR requirements met"
                        ) : (
                          "Bake/CTP quantities must match plate maximums for all plates"
                        )}
                      </Alert>
                    </Grid>
                  )}
                  {(user?.role?.permissions?.includes(`sync_jobs`) ||
                    authData?.type === "super_admin") &&
                    (!details?.bill_details ||
                      details?.bill_details?.payment_logs_count === 0) && (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: "flex",
                          justifyContent: { xs: "flex-start", md: "flex-end" },
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="warning"
                          endIcon={<SyncIcon />}
                          onClick={handleJobSync}
                        >
                          Sync job
                        </Button>
                      </Grid>
                    )}
                </Grid>
                {inventoryAlert.open && (
                  <Grid item xs={12} sx={{ mb: 4 }}>
                    <Alert
                      severity={
                        currentStatus === "ctp" ? "error" : "warning"
                      }
                    >
                      {inventoryAlert.message}
                    </Alert>
                  </Grid>
                )}
                {(nextStatus &&
                  user?.role?.permissions?.includes(
                    `status_update_${currentStatus}_to_${nextStatus}`
                  )) ||
                  (previousStatus &&
                    user?.role?.permissions?.includes("reverse_job_status")) ||
                  ((nextStatus || previousStatus) &&
                    authData?.type === "super_admin") ? (
                  <Card mb={6}>
                    <CardContent>
                      <Paper
                        elevation={3}
                        style={{
                          paddingTop: "1.5%",
                          paddingRight: "2%",
                          paddingLeft: "2%",
                        }}
                      >
                        <Grid container spacing={5}>
                          <Grid container alignItems="center" spacing={2} fullWidth justifyContent={"space-between"} >
                            <Grid item>
                              <Typography variant="h6" gutterBottom color="primary">
                                Status Update
                              </Typography>
                            </Grid>
                            {currentStatus === 'ctp' && (userPermissions?.includes('view_dpr') || authData?.type === "super_admin") && (
                              <Grid item>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={() => productionReportRef.current.scrollIntoView({
                                    behavior: 'smooth'
                                  })}
                                >
                                  DPR Table
                                </Button>
                              </Grid>
                            )}
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            {nextStatus && (
                              <div>
                                Update status &nbsp;
                                <Button
                                  data-testid="update"
                                  onClick={() => handleOpen("next")}
                                  variant="outlined"
                                  disabled={
                                    (currentStatus === "ctp" && (
                                      inventoryAlert.open ||
                                      isCustomerCompanyChanged ||
                                      !hasExistingReport ||
                                      !checkDPRCompletion()
                                    ))
                                  }
                                >
                                  {_.upperCase(currentStatus)}
                                  <ArrowRightAlt />
                                  {_.upperCase(nextStatus)}
                                </Button>
                              </div>
                            )}

                            {previousStatus && authData?.type === "super_admin" && (
                              <div>
                                Revert status &nbsp;
                                <Button
                                  data-testid="update"
                                  color="danger"
                                  variant="outlined"
                                  onClick={() => handleOpen("previous")}
                                >
                                  {_.upperCase(previousStatus)}
                                  <ArrowRightAlt
                                    sx={{ transform: "scaleX(-1)" }}
                                  />
                                  {_.upperCase(currentStatus)}
                                </Button>
                              </div>
                            )}

                            {previousStatus &&
                              authData?.type !== "super_admin" &&
                              user?.role?.permissions?.includes(
                                "reverse_job_status"
                              ) && (
                                <div>
                                  {user?.role?.permissions?.includes(
                                    "reverse_job_status"
                                  )}
                                  Revert status &nbsp;
                                  <Button
                                    data-testid="update"
                                    color="danger"
                                    variant="outlined"
                                    onClick={() => handleOpen("previous")}
                                  >
                                    {_.upperCase(previousStatus)}
                                    <ArrowRightAlt
                                      sx={{ transform: "scaleX(-1)" }}
                                    />
                                    {_.upperCase(currentStatus)}
                                  </Button>
                                </div>
                              )}
                          </Grid>

                          <Modal
                            open={open}
                            onClose={handleDown}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box sx={style}>
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                align="center"
                                color="primary"
                              >
                                Update Status
                              </Typography>
                              {authData?.type === "super_admin" ? (
                                <FormControl fullWidth>
                                  <Select
                                    id="search-field"
                                    value={actionBy}
                                    onChange={(e) =>
                                      setActionBy(e.target.value)
                                    }
                                    displayEmpty
                                  >
                                    <MenuItem value={""} disabled>
                                      Select Action By
                                    </MenuItem>
                                    {ApUsers?.map((user) => {
                                      return (
                                        <MenuItem value={user._id} key={user._id}>
                                          {user.name}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                  <FormHelperText>
                                    Select Action By
                                  </FormHelperText>
                                </FormControl>
                              ) : null}
                              <DocumentUpload
                                documents={documents}
                                setDocuments={setDocuments}
                                images={images}
                                setImages={setImages}
                              />
                              <Button onClick={updateStatus}>Update</Button>
                            </Box>
                          </Modal>

                          <Grid item xs={12} md={3} lg={3}></Grid>
                        </Grid>
                      </Paper>
                    </CardContent>
                  </Card>
                ) : null}

                {/* General Details */}
                <Card mb={6}>
                  <CardContent>
                    <Paper elevation={3} style={{ padding: "2%" }}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="h6" color="primary" gutterBottom>
                            General Details{" "}
                            <Chip
                              label={_.upperCase(currentStatus)}
                              size="small"
                              color="primary"
                              sx={{ mb: 1 }}
                            />
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          lg={6}
                          md={6}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          {(authData?.type === "super_admin" || userPermissions?.includes("delete_jobs")) ? <FormControl component="fieldset" variant="standard">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={is_deleted}
                                  sx={{
                                    color: "#f44336",
                                    "&.Mui-checked": {
                                      color: "#f44336",
                                    },
                                  }}
                                  onChange={(e) =>
                                    setIsDeleted(e.target.checked)
                                  }
                                />
                              }
                              sx={{ color: "#f44336" }}
                              label={<b>DELETE</b>}
                              labelPlacement="start"
                            />
                          </FormControl> :
                            (
                              <Box sx={{ width: "130px", height: "40px" }} />
                            )}
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            type="text"
                            fullWidth
                            size="small"
                            label="Job Id"
                            value={details?.job_id}
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            fullWidth
                            size="small"
                            name="name"
                            value={values?.name}
                            onBlur={handleBlur}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                            onChange={handleChange}
                            InputProps={InputProps}
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            id="search-field"
                            label="Job Name"
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <FormControl
                            error={Boolean(
                              touched.binding_style && errors.binding_style
                            )}
                            fullWidth
                            size="small"
                          >
                            <Select
                              name="binding_style"
                              id="search-field"
                              value={values?.binding_style}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              displayEmpty
                              inputProps={{
                                readOnly:
                                  (currentStatus === "ctp" ||
                                    currentStatus === "delivery" ||
                                    currentStatus === "billing") &&
                                  true,
                              }}
                            >
                              <MenuItem value={""} disabled>
                                Select Binding Style
                              </MenuItem>
                              <MenuItem value={"perfect"}>Perfect</MenuItem>
                              <MenuItem value={"center_pinning"}>
                                Center Pining
                              </MenuItem>
                              <MenuItem value={"perfect_section"}>
                                Perfect Section
                              </MenuItem>
                              <MenuItem value={"wiro"}>Wiro</MenuItem>
                              <MenuItem value={"cut_n_go"}>Cut N Go</MenuItem>
                              <MenuItem value={"punch_n_go"}>
                                Punch N Go
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          {userPermissions?.includes("view_job_cost") ||
                            authData?.type === "super_admin" ? (
                            <TextField
                              type="text"
                              fullWidth
                              size="small"
                              label="Job Total Cost"
                              value={details?.job_total_cost}
                              inputProps={{ readOnly: true }}
                            />
                          ) : (
                            <TextField
                              type="text"
                              fullWidth
                              size="small"
                              label="Job Total Cost"
                              value={"Permission Denied"}
                              inputProps={{ readOnly: true }}
                            />
                          )}
                        </Grid>

                        {/* Customer Details */}
                        <Grid item xs={12} md={3} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.customer_company &&
                              errors.customer_company
                            )}
                          >
                            <Autocomplete
                              disabled={[
                                "ctp",
                                "delivery",
                                "customer_accept",
                                "billing",
                                "payment",
                              ]?.includes(details?.current_status)}
                              disableClearable={true}
                              id="combo-box-demo"
                              options={customerCompanies}
                              value={selectedCustomerCompanyInput}
                              onChange={(event, newValue) => {
                                setIsCustomerCompanyChanged(true);
                                setFormChanged(true);
                                setPreventNavigation(true);
                                if (newValue) {
                                  showErrorAlert(
                                    `Please add plates associated with ${newValue?.name}`
                                  );
                                  setSelectedCustomerCompanyInput(newValue);
                                  setSelectedCustomerCompanyUserInput("");
                                  let defaultAddress =
                                    newValue?.addresses?.[newValue?.default_address];
                                  setFieldValue(
                                    "delivery",
                                    defaultAddress || ""
                                  );
                                  setSelectedCustomerCompanyAddresses(
                                    newValue?.addresses || []
                                  );
                                  setFieldValue("customer_contact_number", "");
                                  getCustomerUsers(
                                    newValue?._id,
                                    setCustomerCompanyUserOptions
                                  );
                                  getInventory(newValue?._id);
                                } else {
                                  showErrorAlert(
                                    "Customer Company cannot be removed"
                                  );
                                }
                                setPlates([]);
                                setInventoryAlert({
                                  ...inventoryAlert,
                                  open: false,
                                });
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) => option?.name || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.customer_company &&
                                    errors.customer_company
                                  )}
                                  helperText={
                                    touched.customer_company &&
                                    errors.customer_company
                                  }
                                  label="Customer Company"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={5} lg={5}>
                          <FormControl
                            fullWidth
                            error={Boolean(touched.delivery && errors.delivery)}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              disableClearable={true}
                              options={selectedCustomerCompanyAddresses}
                              defaultValue={values?.delivery}
                              value={values?.delivery}
                              onChange={(event, newValue) => {
                                setFieldValue("delivery", newValue || "");
                                setFormChanged(true);
                                setPreventNavigation(true);
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) =>
                                option
                                  ? `${option?.address_line_one}, ${option?.address_line_two}, ${option?.city}, ${option?.state}, ${option?.pincode}, India`
                                  : ""
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.delivery && errors.delivery
                                  )}
                                  helperText={
                                    touched.delivery && errors.delivery
                                  }
                                  label="Delivery"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2} lg={2}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.customer_company_user &&
                              errors.customer_company_user
                            )}
                          >
                            <Autocomplete
                              disabled={[
                                "ctp",
                                "delivery",
                                "customer_accept",
                                "billing",
                                "payment",
                              ].includes(details?.current_status)}
                              id="combo-box-demo"
                              disableClearable={true}
                              options={customerCompanyUserOptions}
                              value={selectedCustomerCompanyUserInput}
                              onChange={(event, newValue) => {
                                setSelectedCustomerCompanyUserInput(newValue);
                                setFieldValue(
                                  "customer_contact_number",
                                  newValue?.phone_number || ""
                                );
                                setFormChanged(true);
                                setPreventNavigation(true);
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) => option?.name || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.customer_company_user &&
                                    errors.customer_company_user
                                  )}
                                  helperText={
                                    touched.customer_company_user &&
                                    errors.customer_company_user
                                  }
                                  label="Customer Company User"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2} lg={2}>
                          <TextField
                            name="customer_contact_number"
                            fullWidth
                            size="small"
                            inputProps={{ readOnly: true }}
                            value={values?.customer_contact_number}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.customer_contact_number &&
                              errors.customer_contact_number
                            )}
                            helperText={
                              touched.ap_contact_number &&
                              errors.ap_contact_number
                            }
                            id="search-field"
                            label="Customer Contact Number"
                          />
                        </Grid>

                        {/* AP Company Details */}
                        <Grid item xs={12} md={12} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.ap_company && errors.ap_company
                            )}
                          >
                            <Autocomplete
                              disableClearable={true}
                              id="combo-box-demo"
                              options={ApCompanies}
                              value={ApCompanies.find(
                                (item) => item._id === values?.ap_company
                              )}
                              onChange={(event, newValue) => {
                                setFieldValue(
                                  "ap_company",
                                  newValue?._id || ""
                                );
                                setApUsers([]);
                                setApMachines([]);
                                getApUsers(newValue?._id);
                                getApMachines(newValue?._id);
                                setCurrentApCompany(newValue?._id);
                                setFormChanged(true);
                                setPreventNavigation(true);
                              }}
                              inputValue={values?.ap_company?.name}
                              inputProps={{
                                readOnly:
                                  (currentStatus === "ctp" ||
                                    currentStatus === "delivery" ||
                                    currentStatus === "billing") &&
                                  true,
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) => option?.name || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.ap_company && errors.ap_company
                                  )}
                                  helperText={
                                    touched.ap_company && errors.ap_company
                                  }
                                  label="AP Company"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.ap_company_user && errors.ap_company_user
                            )}
                          >
                            <Autocomplete
                              disableClearable={true}
                              id="combo-box-demo"
                              options={ApUsers}
                              defaultValue={details?.ap_company_user}
                              inputValue={values?.ap_company_user?.name}
                              onChange={(event, newValue) => {
                                setFieldValue(
                                  "ap_company_user",
                                  newValue?._id || ""
                                );
                                if (newValue !== null) {
                                  setFieldValue(
                                    "ap_contact_number",
                                    newValue?.phone_number || ""
                                  );
                                }
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) => option?.name || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.ap_company_user &&
                                    errors.ap_company_user
                                  )}
                                  helperText={
                                    touched.ap_company_user &&
                                    errors.ap_company_user
                                  }
                                  label="AP Company User"
                                  InputProps={{
                                    ...params.InputProps,
                                    readOnly:
                                      (currentStatus === "ctp" ||
                                        currentStatus === "delivery" ||
                                        currentStatus === "billing") &&
                                      true,
                                  }}
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12} lg={3}>
                          <TextField
                            type="text"
                            fullWidth
                            size="small"
                            label="AP Contact Number"
                            value={values?.ap_contact_number}
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} md={12} lg={3}>
                          <TextField
                            type="text"
                            fullWidth
                            size="small"
                            label="Docket By"
                            value={details?.docket_details?.action_by?.name}
                            inputProps={{ readOnly: true }}
                          />
                        </Grid>

                        {/* Job Data */}
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            name="pc_ap"
                            fullWidth
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            size="small"
                            value={values?.pc_ap}
                            onBlur={handleBlur}
                            error={Boolean(touched.pc_ap && errors.pc_ap)}
                            helperText={touched.pc_ap && errors.pc_ap}
                            onChange={handleChange}
                            InputProps={InputProps}
                            id="search-field"
                            label="PC-AP"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            size="small"
                            name="total_form"
                            value={values?.total_form}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.total_form && errors.total_form
                            )}
                            helperText={touched.total_form && errors.total_form}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("total_form")(e);
                              }
                            }}
                            id="search-field"
                            label="Total Form"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            name="cut"
                            fullWidth
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            size="small"
                            value={values?.cut}
                            onBlur={handleBlur}
                            error={Boolean(touched.cut && errors.cut)}
                            helperText={touched.cut && errors.cut}
                            onChange={handleChange}
                            id="search-field"
                            label="Cut"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            name="open_height"
                            fullWidth
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            size="small"
                            value={values?.open_height}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.open_height && errors.open_height
                            )}
                            helperText={
                              touched.open_height && errors.open_height
                            }
                            onChange={handleChange}
                            id="search-field"
                            label="Open-Height"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            name="open_width"
                            fullWidth
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            size="small"
                            value={values?.open_width}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.open_width && errors.open_width
                            )}
                            helperText={touched.open_width && errors.open_width}
                            onChange={handleChange}
                            id="search-field"
                            label="Open-Width"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            size="small"
                            name="page"
                            value={values?.page}
                            onBlur={handleBlur}
                            error={Boolean(touched.page && errors.page)}
                            helperText={touched.page && errors.page}
                            onChange={handleChange}
                            id="search-field"
                            label="Page"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            name="fb"
                            fullWidth
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            size="small"
                            value={values?.fb}
                            onBlur={handleBlur}
                            error={Boolean(touched.fb && errors.fb)}
                            helperText={touched.fb && errors.fb}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("fb")(e);
                              }
                            }}
                            id="search-field"
                            label="F/B"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            size="small"
                            name="sb"
                            value={values?.sb}
                            onBlur={handleBlur}
                            error={Boolean(touched.sb && errors.sb)}
                            helperText={touched.sb && errors.sb}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("sb")(e);
                              }
                            }}
                            id="search-field"
                            label="S/B"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            size="small"
                            name="dg"
                            value={values?.dg}
                            onBlur={handleBlur}
                            error={Boolean(touched.dg && errors.dg)}
                            helperText={touched.dg && errors.dg}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("dg")(e);
                              }
                            }}
                            id="search-field"
                            label="D/G"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                            size="small"
                            name="os"
                            value={values?.os}
                            onBlur={handleBlur}
                            error={Boolean(touched.os && errors.os)}
                            helperText={touched.os && errors.os}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("os")(e);
                              }
                            }}
                            id="search-field"
                            label="O/S"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                          <FormControl
                            fullWidth
                            error={Boolean(touched.category && errors.category)}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              options={categories}
                              defaultValue={details?.category}
                              onChange={(event, newValue) => {
                                setFieldValue("category", newValue || "");
                                setFormChanged(true);
                                setPreventNavigation(true);
                              }}
                              onBlur={handleBlur}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.category && errors.category
                                  )}
                                  helperText={
                                    touched.category && errors.category
                                  }
                                  label="Category"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <FormControl
                            error={Boolean(
                              touched.recieved_date && errors.recieved_date
                            )}
                            fullWidth
                          >
                            <DateTimePicker
                              name="recieved_date"
                              readOnly={
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true
                              }
                              renderInput={(props) => (
                                <TextField size="small" {...props} />
                              )}
                              label="Recieved Date"
                              value={values?.recieved_date || null}
                              onChange={(newValue) => {
                                let selectedDate = newValue;
                                var month = (
                                  "0" + parseInt(selectedDate?.getMonth() + 1)
                                ).slice(-2);
                                var day = (
                                  "0" + parseInt(selectedDate?.getDate())
                                ).slice(-2);
                                var hour = parseInt(selectedDate?.getHours());
                                var minute = parseInt(
                                  selectedDate?.getMinutes()
                                );
                                let date =
                                  selectedDate?.getFullYear() +
                                  "-" +
                                  month +
                                  "-" +
                                  day +
                                  ":" +
                                  hour +
                                  ":" +
                                  minute;
                                setFieldValue("recieved_date", date);
                              }}
                              onBlur={handleBlur}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                          <FormControl
                            error={Boolean(
                              touched.required_date && errors.required_date
                            )}
                            fullWidth
                          >
                            <DateTimePicker
                              name="required_date"
                              readOnly={
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true
                              }
                              renderInput={(props) => (
                                <TextField size="small" {...props} />
                              )}
                              label="Delivery Date"
                              value={values?.required_date || null}
                              onChange={(newValue) => {
                                let selectedDate = newValue;
                                var month = (
                                  "0" + parseInt(selectedDate?.getMonth() + 1)
                                ).slice(-2);
                                var day = (
                                  "0" + parseInt(selectedDate?.getDate())
                                ).slice(-2);
                                var hour = parseInt(selectedDate?.getHours());
                                var minute = parseInt(
                                  selectedDate?.getMinutes()
                                );
                                let date =
                                  selectedDate?.getFullYear() +
                                  "-" +
                                  month +
                                  "-" +
                                  day +
                                  ":" +
                                  hour +
                                  ":" +
                                  minute;
                                setFieldValue("required_date", date);
                              }}
                              onBlur={handleBlur}
                            />
                          </FormControl>
                        </Grid>

                        {/* Refer Job */}
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth>
                            <Autocomplete
                              id="combo-box-demo"
                              options={jobs}
                              value={
                                jobs.length !== 0 &&
                                jobs.find(
                                  (item) => item._id === values?.job_refer
                                )
                              }
                              onChange={(event, newValue) => {
                                setFieldValue("job_refer", newValue?._id || "");
                                setFormChanged(true);
                                setPreventNavigation(true);
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) =>
                                option?.job_id + " - " + option?.name
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  label="Referred Job"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <TextField
                            multiline
                            name="instructions"
                            fullWidth
                            size="small"
                            value={values?.instructions}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.instructions && errors.instructions
                            )}
                            helperText={
                              touched.instructions && errors.instructions
                            }
                            onChange={handleChange}
                            id="search-field"
                            label="Job Instructions"
                            inputProps={{
                              readOnly:
                                (currentStatus === "ctp" ||
                                  currentStatus === "delivery" ||
                                  currentStatus === "billing") &&
                                true,
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>

                {/* Plate Details */}
                <Card mb={6}>
                  <CardContent>
                    <Paper elevation={3} style={{ padding: "2%" }}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} md={12}>
                          <Typography variant="h6" gutterBottom color="primary">
                            Plate Details
                          </Typography>
                        </Grid>

                        {plates?.map((pl, i) => {
                          return (
                            <React.Fragment key={i}>
                              <Grid
                                item
                                xs={12}
                                lg={4}
                                md={4}
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <FormControl fullWidth>
                                  <Select
                                    required
                                    id="search-field"
                                    size="small"
                                    value={pl?.plate_id || ""}
                                    onChange={(e) => {
                                      const selectedPlateId = e.target.value;
                                      plateHandle(i, "plate_id")(e);
                                      setGripper(selectedPlateId, i);
                                      const inventoryItem = inventory?.find(it => it?.plate_id === selectedPlateId);
                                      if (inventoryItem) {
                                        setPlates(prev => {
                                          const updated = [...prev];
                                          updated[i] = {
                                            ...updated[i],
                                            baking_cost: inventoryItem?.baking_cost,
                                            print_cost: inventoryItem?.print_cost,
                                            selling_cost: inventoryItem?.selling_cost,
                                          };
                                          return updated;
                                        });
                                      }
                                      totalPrice();
                                    }}
                                    inputProps={{
                                      readOnly:
                                        (currentStatus === "delivery" ||
                                          currentStatus === "billing") &&
                                        true,
                                    }}
                                    displayEmpty
                                  >
                                    <MenuItem value={""} disabled>
                                      Select Plate
                                    </MenuItem>
                                    {inventory?.map((plate) => {
                                      return (
                                        <MenuItem key={plate?.plate_id} value={plate?.plate_id}>
                                          {plate?.height}X{plate?.width}X
                                          {plate?.thickness}_{plate?.brand?.name}_
                                          {plate?.technology?.name}_
                                          {plate?.company}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                                {currentStatus !== "delivery" &&
                                  currentStatus !== "billing" && (
                                    <CloseIcon
                                      onClick={() => {
                                        removePlate(i, pl?.plate_id);
                                      }}
                                      sx={{
                                        height: "100%",
                                        border: "1px solid lightGrey",
                                        borderLeft: 0,
                                        borderRadius: "0 5px 5px 0",
                                        padding: "0 2px",
                                        cursor: "pointer",
                                      }}
                                    />
                                  )}
                              </Grid>
                              <Grid item xs={12} md={4} lg={2}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  id="search-field"
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  value={pl?.gripper || ""}
                                  onChange={plateHandle(i, "gripper")}
                                  label="Gripper"
                                  inputProps={{
                                    readOnly:
                                      (currentStatus === "delivery" ||
                                        currentStatus === "billing") &&
                                      true,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} lg={2}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  type="text"
                                  onWheel={(e) => e.target.blur()}
                                  id="search-field"
                                  value={pl?.screen}
                                  onChange={plateHandle(i, "screen")}
                                  label="Screen + Paper"
                                  inputProps={{
                                    readOnly:
                                      (currentStatus === "delivery" ||
                                        currentStatus === "billing") &&
                                      true,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} lg={2}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  id="search-field"
                                  value={pl?.set}
                                  onChange={plateHandle(i, "set")}
                                  label="Set"
                                  inputProps={{
                                    readOnly:
                                      (currentStatus === "delivery" ||
                                        currentStatus === "billing") &&
                                      true,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} lg={2}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  id="standard-number"
                                  label="CTP"
                                  inputProps={{
                                    readOnly:
                                      (currentStatus === "delivery" ||
                                        currentStatus === "billing") &&
                                      true,
                                  }}
                                  value={pl?.ctp_plate_count}
                                  onChange={plateHandle(i, "ctp_plate_count")}
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  disabled={currentStatus === "ctp"}
                                  m={2}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} lg={2}>
                                <TextField
                                  id="standard-number"
                                  label="Bake Quantity"
                                  fullWidth
                                  size="small"
                                  value={pl?.bake}
                                  onChange={(e) => {
                                    plateHandle(i, "bake")(e);
                                  }}
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  inputProps={{
                                    readOnly:
                                      (currentStatus === "delivery" ||
                                        currentStatus === "billing") &&
                                      true,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} lg={2}>
                                <TextField
                                  id="standard-number"
                                  label="Printout Quantity"
                                  value={pl?.printout}
                                  onChange={(e) => {
                                    plateHandle(i, "printout")(e);
                                  }}
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  fullWidth
                                  size="small"
                                  inputProps={{
                                    readOnly:
                                      (currentStatus === "delivery" ||
                                        currentStatus === "billing") &&
                                      true,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} md={4} lg={2}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  id="standard-number"
                                  label="Total Quantity"
                                  disabled={nextStatus !== "delivery"}
                                  value={pl?.quantity}
                                  onChange={(e) => {
                                    plateHandle(i, "quantity")(e);
                                    totalPrice();
                                  }}
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  m={2}
                                  inputProps={{
                                    readOnly:
                                      currentStatus === "delivery" ||
                                      (currentStatus === "billing" && true),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} lg={2} md={3}>
                                <FormControl
                                  fullWidth
                                  component="fieldset"
                                  variant="standard"
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        onChange={plateHandle(i, "not_to_bill")}
                                        checked={pl?.not_to_bill || false}
                                      />
                                    }
                                    label={"Not to Bill"}
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} lg={2} md={3}>
                                <FormControl
                                  fullWidth
                                  component="fieldset"
                                  variant="standard"
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        onChange={plateHandle(
                                          i,
                                          "production_rejection"
                                        )}
                                        disabled={currentStatus !== "ctp"}
                                        checked={
                                          pl?.production_rejection || false
                                        }
                                      />
                                    }
                                    label={"Production-Rejection"}
                                  />
                                </FormControl>
                                <br />
                                <br />
                              </Grid>
                              {priceChanges[i] && (
                                <Grid item xs={12}>
                                  <Alert severity="warning" sx={{ mb: 2 }}>
                                    Plate price has been updated.
                                    <Button size="small" onClick={() => applyNewPrices(i)}>Use New Price</Button>
                                    <Button size="small" onClick={() => keepOldPrices(i)}>Keep Old Price</Button>
                                  </Alert>
                                </Grid>
                              )}
                            </React.Fragment>
                          );
                        })}
                        <Grid
                          item
                          xs={12}
                          md={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
                            onClick={addPlate}
                            mr={2}
                            variant="contained"
                            color="primary"
                            disabled={
                              missingPermissions.length > 0 ||
                              currentStatus === "delivery" ||
                              currentStatus === "billing"
                            }
                          >
                            Add Plate
                            <AddIcon />
                          </Button>
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>

                {/* Production Report Modals */}
                {openCreateReportModal && <Modal open={openCreateReportModal} onClose={() => setOpenCreateReportModal(false)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingX: '10%' }}>
                  <CreateProductionReport
                    jobId={details?._id}
                    jobDisplayId={details?.job_id}
                    apCompany={details?.ap_company?._id}
                    setUp={setUp}
                    up={up}
                    plates={details?.plates}
                    onClose={() => setOpenCreateReportModal(false)}
                    setSuccess={setSuccess}
                    showErrorAlert={showErrorAlert}
                    setMessage={setMessage}
                    snackRef={snackRef}
                    apMachines={apMachines}
                  />
                </Modal>}
                {openUpdateReportModal && <Modal open={openUpdateReportModal} onClose={() => setOpenUpdateReportModal(false)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingX: '10%' }}>
                  <UpdateProductionReport
                    productionReport={selectedProductionReport}
                    jobDetails={details}
                    setUp={setUp}
                    up={up}
                    onClose={() => setOpenUpdateReportModal(false)}
                    setSuccess={setSuccess}
                    showErrorAlert={showErrorAlert}
                    setMessage={setMessage}
                    snackRef={snackRef}
                    apMachines={apMachines}
                  />
                </Modal>}

                {(userPermissions?.includes('view_dpr') || authData?.type === "super_admin") && (details?.current_status === 'ctp') ?
                  (<ProductionReportsTable
                    productionReports={productionReports}
                    metadata={metadata}
                    loading={loading}
                  />)
                  : null}

                {productionReports.length > 0 && <Modal open={openLogsModal} onClose={() => setOpenLogsModal(false)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Paper elevation={3} style={{ padding: "2%", marginBottom: 20, maxHeight: "70vh", overflowY: "auto" }}>
                    <Typography variant="h5" color="primary" mb={6} gutterBottom>
                      Production Report Logs
                    </Typography>
                    <TableContainer
                      component={Paper}
                      elevation={3}
                      sx={{ borderRadius: 2, backgroundColor: "white" }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ backgroundColor: '#eeeeee' }}>
                            <TableCell><strong>Action</strong></TableCell>
                            <TableCell><strong>Timestamp</strong></TableCell>
                            <TableCell><strong>AP User</strong></TableCell>
                            <TableCell><strong>Description</strong></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {audit_logs?.map((log, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                backgroundColor: index % 2 === 0 ? '#ffffff' : '#f4f4f4',
                                '&:hover': { backgroundColor: '#e0e0e0' },
                              }}
                            >
                              <TableCell>{log?.action}</TableCell>
                              <TableCell>
                                {new Date(log?.timestamp).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}
                              </TableCell>
                              <TableCell>
                                {log?.action_by?.name || log?.action_by}
                              </TableCell>
                              <TableCell>{log?.description || '--'}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Modal>}

                {/* Studio Images */}
                <Card mb={6}>
                  <CardContent>
                    <Paper elevation={3} style={{ padding: "2%" }}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} md={12} lg={12}>
                          <Accordion>
                            <AccordionSummary
                              expandIcon={<ExpandMore />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography
                                color="primary"
                                variant="h6"
                                gutterBottom
                              >
                                Studio Images
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid item xs={12} md={12} lg={12}></Grid>
                              <Timeline>
                                {urls &&
                                  urls?.map((url, ind) => {
                                    return (
                                      <TimelineItem key={ind}>
                                        <TimelineOppositeContent
                                          align="left"
                                          variant="body2"
                                          color="secondary"
                                          style={{
                                            maxWidth: "10%",
                                          }}
                                        >
                                          <br />
                                          <br />
                                          {_.upperCase(url?.stage)}
                                        </TimelineOppositeContent>
                                        <TimelineSeparator>
                                          <TimelineConnector />
                                          <TimelineDot
                                            color="primary"
                                            variant="outlined"
                                          ></TimelineDot>
                                          <TimelineConnector />
                                        </TimelineSeparator>
                                        <TimelineContent>
                                          <Paper
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              width: "100%",
                                            }}
                                            mt={3}
                                          >
                                            <Box
                                              component="img"
                                              width="90px"
                                              height="80px"
                                              src={
                                                url?.type === "pdf"
                                                  ? "/static/img/images/pdf.png"
                                                  : url?.url
                                              }
                                              style={{ cursor: "pointer" }}
                                            />
                                            <TextField
                                              fullWidth
                                              margin="dense"
                                              m={2}
                                              style={{
                                                marginLeft: 32,
                                                width: "100%",
                                              }}
                                              inputProps={{ readOnly: true }}
                                              id="standard-required"
                                              label="Document Name"
                                              value={url?.name || ""}
                                            />
                                            <Grid item>
                                              <a
                                                href={url?.url}
                                                style={{
                                                  color: "inherit",
                                                  textDecoration: "inherit",
                                                }}
                                                download={`${url?.name}.${url?.type}`}
                                              >
                                                <FileDownload
                                                  style={{
                                                    marginLeft: 32,
                                                    cursor: "pointer",
                                                  }}
                                                />
                                              </a>
                                            </Grid>
                                            <Grid item>
                                              <Clear
                                                onClick={() =>
                                                  deleteDocument(url?.key)
                                                }
                                                style={{
                                                  color: "red",
                                                  marginLeft: 32,
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </Grid>
                                          </Paper>
                                        </TimelineContent>
                                      </TimelineItem>
                                    );
                                  })}
                              </Timeline>
                            </AccordionDetails>
                          </Accordion>
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>

                <Grid item xs={12} md={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={
                      isSubmitting ||
                      missingPermissions.length > 0 ||
                      currentStatus === "delivery" ||
                      currentStatus === "billing" ||
                      currentStatus === "payment"
                    }
                  >
                    Save Changes
                  </Button>
                </Grid>
              </form>
            ) : (
              <Loading />
            )}
          </>
        )}
      </Formik>
    </>
  );
}

const getUserCompanies = async (
  setCustomerCompanies,
  setApCompanies,
  id,
  setDetails,
  setUrls,
  setLoader,
  setErr,
  setInitialCustomerCompanyUsers
) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData?.access_token,
      },
    };
    const apCompany = await axios.get(
      `/api/v1/${userData?.type}/ap_company`,
      config
    );

    if (apCompany?.data?.success) {
      setApCompanies(apCompany?.data?.data?.data || []);
    }

    const customerCompany = await axios.get(
      `/api/v1/${userData?.type}/customer_company?limit=500`,
      config
    );

    if (customerCompany?.data?.success) {
      setCustomerCompanies(customerCompany?.data?.data?.data || []);
    }
    getJobDetails(
      id,
      setDetails,
      setUrls,
      setLoader,
      setErr,
      setInitialCustomerCompanyUsers
    );
  } catch (e) {
    setLoader(false);
    console.log(e?.response);
  }
};

const getCompanyInventory = async (
  ap_company,
  plates,
  inventoryAlert,
  setInventoryAlert
) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData?.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${userData?.type}/plate_inventory/get_inventory?ap_company=${ap_company}&no_table=${true}`,
      config
    );
    if (data?.success) {
      if (data?.data?.plates === undefined) {
        setInventoryAlert({
          ...inventoryAlert,
          open: true,
          message: "No inventory available for this AP company",
        });
      } else {
        let msg = "Insufficient plate(s)";
        let opn = false;
        plates?.map((dt, index) => {
          let temp = data?.data?.plates?.find(
            (item) => item?.plate === dt?.plate_id
          );
          let quantity = temp !== undefined ? temp?.quantity : 0;
          if (quantity < dt?.ctp_plate_count) {
            msg += ` {${index + 1}} [ ${dt?.plate_details?.height}X${dt?.plate_details?.width}X${dt?.plate_details?.thickness}_${dt?.plate_details?.brand?.name}_${dt?.plate_details?.technology?.name} => Required: ${dt?.ctp_plate_count} | Available: ${quantity} ]`;
            opn = true;
            setInventoryAlert({ ...inventoryAlert, open: true, message: msg });
          }
        });
      }
    }
  } catch (e) {
    console.log(e);
  }
};

const getInitialCustomerCompanyUsers = async (
  jobId,
  setLinks,
  setUrls,
  customerCompanyId,
  setInitialCustomerCompanyUsers,
  setLoader
) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData?.access_token,
      },
    };

    const { data: response } = await axios.get(
      `/api/v1/${userData?.type}/customer_company_user?company_id=${customerCompanyId}`,
      config
    );
    if (response?.success) {
      setInitialCustomerCompanyUsers(response?.data?.data || []);
      const studio = await axios.get(
        `/api/v1/${userData?.type}/jobs/${jobId}/studio_images`,
        config
      );
      if (studio?.data?.success) {
        setLinks(studio?.data?.data, setUrls, setLoader);
      }
    }
  } catch (e) {
    console.log(e);
    setLoader(false);
  }
};

const getJobDetails = async (
  id,
  setDetails,
  setUrls,
  setLoader,
  setErr,
  setInitialCustomerCompanyUsers
) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData?.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/jobs/${id}`,
      config
    );

    if (data?.success) {
      setDetails(data?.data);
      getInitialCustomerCompanyUsers(
        id,
        setLinks,
        setUrls,
        data?.data?.customer_company?._id,
        setInitialCustomerCompanyUsers,
        setLoader
      );
    }
  } catch (e) {
    setLoader(false);
  }
};

const setLinks = (document, setUrls, setLoader) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let urls = [];
    document?.map((doc) => {
      const type =
        doc?.studio_images?.document_storage_info?.key?.split(".")[1];
      urls.push({
        url: `/api/v1/${authData?.type}/media/${doc?.studio_images?.document_storage_info?.key}`,
        name: doc?.studio_images?.document_title,
        type: type,
        key: doc?.studio_images?.document_storage_info?.key,
        stage: doc?.studio_images?.document_upload_stage,
      });
    });
    sendRequests(urls, setLoader, setUrls);
  } catch (e) {
    console.log(e);
  }
};

const sendRequests = async (urls, setLoader, setUrls) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let num = urls?.length;
    if (num === 0) {
      setLoader(false);
    }
    let n = 0;
    let allUrls = [];
    let promiseArr = urls?.map((l) => {
      let PROD_URL = "";
      if (process.env.NODE_ENV === "development") {
        PROD_URL = process.env.REACT_APP_BACKEND_DEV_API_URL;
      } else {
        PROD_URL = process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      }
      fetch(PROD_URL + l?.url, {
        headers: {
          Authorization: "Bearer " + authData?.access_token,
        },
        method: "GET",
      })
        .then(async (resp) => {
          return resp.arrayBuffer();
        })
        .then(async (res) => {
          n++;
          if (l?.type === "pdf") {
            const myFile = new Blob([res], { type: "application/pdf" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({
              url: url,
              name: l?.name,
              type: l?.type,
              key: l?.key,
              stage: l?.stage,
            });
          } else {
            const myFile = new Blob([res], { type: "image/png" });
            const url = URL.createObjectURL(myFile);
            allUrls.push({
              url: url,
              name: l?.name,
              type: l?.type,
              key: l?.key,
              stage: l?.stage,
            });
          }
          if (n === num) {
            setUrls(allUrls);
            setLoader(false);
          }
        });
    });
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function EditJob({ auths }) {
  const { job_id } = useParams();

  const [details, setDetails] = useState([]);
  const [user, setUser] = useState([]);
  const [loader, setLoader] = useState(true);
  const [ApCompanies, setApCompanies] = useState([]);
  const [customerCompanies, setCustomerCompanies] = useState([]);
  const [initialCustomerCompanyUsers, setInitialCustomerCompanyUsers] =
    useState([]);
  const [up, setUp] = useState(0);
  const [urls, setUrls] = useState([]);
  const snackRef = useRef(null);
  const [err, setErr] = useState(null);
  const [success, setSuccess] = useState(null);
  const [missingPermissions, setMissingPermissions] = useState([]);
  let requiredPermissions = [
    "view_customer_company_list",
    "view_job_details",
    "customer_company_plate_list_view",
  ];

  const [state, setState] = useState({
    op: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, op } = state;
  const handleClick = (newState) => () => {
    setState({ op: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, op: false });
  };

  useEffect(() => {
    if (auths?.user) {
      setUser(auths.user);
      let userPermissions = auths?.user?.role?.permissions;
      if (userPermissions) {
        const missing = _.difference(requiredPermissions, userPermissions);
        setMissingPermissions(missing);
        if (missing.length > 0) {
          swal(
            "",
            `You are unauthorized to complete this action because you do not have the following permissions

            ${_.toUpper(missing.join(", ").replace(/_/g, " "))}
            `,
            "error"
          );
        }
      }

      getUserCompanies(
        setCustomerCompanies,
        setApCompanies,
        job_id,
        setDetails,
        setUrls,
        setLoader,
        setErr,
        setInitialCustomerCompanyUsers
      );
    }
  }, [auths?.user, up]);

  useEffect(() => {
    if (err) {
      snackRef.current?.click();
    }
  }, [err]);

  if (!loader) {
    return (
      <React.Fragment>
        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={op}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          {err ? (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          ) : success ? (
            <Alert mt={2} mb={4} severity="success">
              {success}
            </Alert>
          ) : null}
        </Snackbar>

        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              EDIT JOB{" "}
              <span style={{ color: "#a9a9a9" }}>
                [{details?.job_id} | {details?.customer_company?.name}]
              </span>
            </Typography>
          </Grid>

          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/jobs">
                All Jobs
              </Link>
              <Typography>Edit Job</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <FormDetails
              missingPermissions={missingPermissions}
              customerCompanies={customerCompanies}
              auths={auths}
              ApCompanies={ApCompanies}
              user={user}
              details={details}
              up={up}
              setUp={setUp}
              urls={urls}
              job_id={job_id}
              setUrls={setUrls}
              userPermissions={auths?.user?.role?.permissions || []}
              initialCustomerCompanyUsers={initialCustomerCompanyUsers}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(EditJob);